export default __webpack_public_path__ + "/img/dep04.5f3bee63.jpg";